import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive'
import './permission'
import plugins from './plugins' // plugins
const app = createApp(App).use(store).use(router).use(plugins)
directive(app)
app.mount('#app')
